import { COLOR_PALETTE } from 'constants/ui';

export const settingsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: ({ palette }) => palette.background.secondary,
  position: 'relative',
};

export const settingsHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '12px 16px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const backButtonStyles = {
  padding: '4px',
  color: ({ palette }) => palette.text.secondary,
};

export const settingsTitleStyles = {
  color: ({ palette }) => palette.text.strong,
};

export const settingsBodyStyles = {
  flex: 1,
  overflow: 'auto',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

export const deviceSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const deviceLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const selectStyles = {
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  fontSize: '14px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: ({ palette }) => palette.border.default,
  },
  '& .MuiSelect-select': {
    padding: '10px 12px',
  },
};

export const disabledSelectStyles = {
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: '8px',
  fontSize: '14px',
  opacity: 0.6,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: ({ palette }) => palette.border.light,
  },
  '& .MuiSelect-select': {
    padding: '10px 12px',
  },
};

export const testButtonStyles = {
  alignSelf: 'flex-start',
  textTransform: 'none',
  fontSize: '13px',
  color: COLOR_PALETTE.BRAND[6],
  borderColor: COLOR_PALETTE.BRAND[6],
  borderRadius: '6px',
  padding: '4px 12px',
};

export const inlinePermissionStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '6px',
  padding: '10px 12px',
  backgroundColor: COLOR_PALETTE.BLUE[1],
  borderRadius: '8px',
  border: `1px solid ${COLOR_PALETTE.BLUE[3]}`,
};

export const inlinePermissionTextStyles = {
  fontSize: '12px',
  color: COLOR_PALETTE.BLUE[8],
};

export const inlinePermissionButtonStyles = {
  textTransform: 'none',
  fontSize: '12px',
  padding: '2px 10px',
  borderRadius: '6px',
  minHeight: 'unset',
};

export const inlineDeniedStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 12px',
  backgroundColor: COLOR_PALETTE.ORANGE[1],
  borderRadius: '8px',
  border: `1px solid ${COLOR_PALETTE.ORANGE[3]}`,
};

export const inlineDeniedIconStyles = {
  color: COLOR_PALETTE.ORANGE[6],
};

export const inlineDeniedTextStyles = {
  fontSize: '12px',
  color: COLOR_PALETTE.ORANGE[8],
};

export const fallbackNoticeStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  backgroundColor: COLOR_PALETTE.ORANGE[1],
  borderRadius: '8px',
  border: `1px solid ${COLOR_PALETTE.ORANGE[3]}`,
};

export const fallbackIconStyles = {
  color: COLOR_PALETTE.ORANGE[6],
};

export const fallbackTextStyles = {
  fontSize: '12px',
  color: COLOR_PALETTE.ORANGE[8],
};

export const micLevelContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const micLevelLabelStyles = {
  fontSize: '11px',
  color: ({ palette }) => palette.text.placeholder,
  flexShrink: 0,
};

export const micLevelBarOuterStyles = {
  flex: 1,
  height: '8px',
  backgroundColor: ({ palette }) => palette.background.disabled,
  borderRadius: '4px',
  overflow: 'hidden',
};

export const micLevelBarInnerStyles = {
  height: '100%',
  minWidth: '2%',
  borderRadius: '4px',
  backgroundColor: COLOR_PALETTE.GREEN[6],
  transition: 'width 80ms linear',
};

export const loadingContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  gap: '12px',
};

export const loadingTextStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const deviceChangeToastStyles = {
  position: 'absolute',
  bottom: '12px',
  left: '12px',
  right: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  backgroundColor: COLOR_PALETTE.GRAY[9],
  borderRadius: '8px',
  zIndex: 10,
  animation: 'fadeInUp 200ms ease-out',
  '@keyframes fadeInUp': {
    from: { opacity: 0, transform: 'translateY(8px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
};

export const deviceChangeToastIconStyles = {
  color: '#fff',
};

export const deviceChangeToastTextStyles = {
  fontSize: '12px',
  color: '#fff',
  flex: 1,
};

export const deviceChangeToastCloseStyles = {
  padding: '2px',
  color: COLOR_PALETTE.GRAY[5],
  '&:hover': {
    color: '#fff',
  },
};

// Voicemail greeting selector (DEV-1575)
export const greetingNoneOptionStyles = {
  fontStyle: 'italic',
  color: ({ palette }) => palette.text.placeholder,
};

export const greetingManageLinkStyles = {
  color: COLOR_PALETTE.BRAND[6],
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
};
